import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8a211d', // Burgundy Red
      light: '#a03d37',
      dark: '#6f1a18',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#2f2522', // Dark Charcoal Brown
      light: '#4a3d3a',
      dark: '#1a1412',
      contrastText: '#FFFFFF',
    },
    accent: {
      main: '#D4A853', // Gold accent for highlights on dark backgrounds
      light: '#E0C07A',
      dark: '#B8923E',
      contrastText: '#2f2522',
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
    success: {
      main: '#2E7D32',
    },
    warning: {
      main: '#ED6C02',
    },
    error: {
      main: '#D32F2F',
    },
    info: {
      main: '#D4A853', // Gold accent for info/highlights
      light: '#E0C07A',
      dark: '#B8923E',
      contrastText: '#2f2522',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.4,
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.5,
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.7,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          padding: '10px 30px',
          fontWeight: 600,
        },
        contained: {
          boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
        },
        containedPrimary: {
          boxShadow: '0 4px 14px 0 rgba(138,33,29,0.3)',
          '&:hover': {
            boxShadow: '0 6px 20px 0 rgba(138,33,29,0.4)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
          },
        },
      },
    },
  },
});

export default theme;